import { Volume2, Video, Sun, Truck, Clapperboard, MonitorPlay, Hotel } from "lucide-react";

export const SKILLS = [
  { id: "audio", label: "Audio", icon: Volume2, color: "bg-cyan-500/10 text-cyan-300 border-cyan-500/30" },
  { id: "video", label: "Video", icon: Video, color: "bg-purple-500/10 text-purple-300 border-purple-500/30" },
  { id: "videomaker", label: "Videomaker", icon: Clapperboard, color: "bg-fuchsia-500/10 text-fuchsia-300 border-fuchsia-500/30" },
  { id: "luci", label: "Luci", icon: Sun, color: "bg-amber-500/10 text-amber-300 border-amber-500/30" },
  { id: "logistica", label: "Logistica", icon: Truck, color: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30" },
  { id: "ledwall", label: "Ledwall", icon: MonitorPlay, color: "bg-sky-500/10 text-sky-300 border-sky-500/30" },
  { id: "hotel", label: "Hotel", icon: Hotel, color: "bg-orange-500/10 text-orange-300 border-orange-500/30" },
];

export const skillMap = Object.fromEntries(SKILLS.map((s) => [s.id, s]));

export const CATEGORIES = [
  { id: "SRH", chip: "bg-rose-500/15 text-rose-300 border-rose-500/40", dot: "bg-rose-400" },
  { id: "SERVICE", chip: "bg-sky-500/15 text-sky-300 border-sky-500/40", dot: "bg-sky-400" },
  { id: "GALILEI", chip: "bg-amber-500/15 text-amber-300 border-amber-500/40", dot: "bg-amber-400" },
  { id: "BENETTI", chip: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40", dot: "bg-emerald-400" },
  { id: "PARRPRO", chip: "bg-violet-500/15 text-violet-300 border-violet-500/40", dot: "bg-violet-400" },
  { id: "UNIPI", chip: "bg-blue-500/15 text-blue-300 border-blue-500/40", dot: "bg-blue-400" },
  { id: "FILARI", chip: "bg-orange-500/15 text-orange-300 border-orange-500/40", dot: "bg-orange-400" },
  { id: "GPR", chip: "bg-fuchsia-500/15 text-fuchsia-300 border-fuchsia-500/40", dot: "bg-fuchsia-400" },
  { id: "MAGAZZINO", chip: "bg-teal-500/15 text-teal-300 border-teal-500/40", dot: "bg-teal-400" },
];
export const categoryColorMap = Object.fromEntries(CATEGORIES.map((c) => [c.id, c]));

export const STATUS = {
  in_attesa: { label: "In Attesa", color: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  disponibile: { label: "Disponibile", color: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  forse: { label: "Forse", color: "bg-violet-500/15 text-violet-300 border-violet-500/30" },
  non_disponibile: { label: "Non Disponibile", color: "bg-rose-500/15 text-rose-300 border-rose-500/30" },
  confermato: { label: "Confermato", color: "bg-blue-600 text-white border-blue-400" },
};

export const TZ = "Europe/Rome";
export const romeNow = () => new Date(new Date().toLocaleString("en-US", { timeZone: TZ }));
export const romeTodayKey = () => new Date().toLocaleDateString("sv-SE", { timeZone: TZ });

export function formatDate(d) {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric", timeZone: TZ });
  } catch {
    return d;
  }
}

export function formatRange(start, end) {
  if (!end || end === start) return formatDate(start);
  return `${formatDate(start)} → ${formatDate(end)}`;
}

export function groupRequests(list, keyFn) {
  const m = new Map();
  [...(list || [])].sort((a, b) => (a.date || "").localeCompare(b.date || "")).forEach((r) => {
    const k = keyFn(r);
    if (!m.has(k)) m.set(k, []);
    m.get(k).push(r);
  });
  return [...m.values()];
}

export function dayLabel(s, long = false) {
  if (!s) return "";
  return new Date(s + "T00:00:00").toLocaleDateString("it-IT", long
    ? { weekday: "long", day: "2-digit", month: "long" }
    : { weekday: "short", day: "2-digit", month: "2-digit" });
}

